<template>
  <div class="customer-search-page">
    <div class="subheader-wrapper">
      <div class="col" style="margin-left: -15px">
        <h2>Customer Search</h2>
      </div>
      <div class="col" style="text-align: right">
        <i class="fa fa-plus" @click="addNewPrivateCustomer" aria-hidden="true" style="cursor:pointer"></i>
      </div>   
    </div>  
    <hr>
    <div class="full-screen-table">
      <BasicDataGrid
      :dataSource="customers"
      :dataGridKey="dataGridKey"
      gridRef="customerSearchGrid"
      :columns="columns"
      :showColumnLines="true"
      :actions="actions"
      :searchEntireGrid="false"
      @editCustomer="editCustomer"
      :allowExport="false"
      :multiSelect="false"
      @checkout="checkout"/>
    </div>
    <Modal ref="editPrivateCustomerModal">
      <PrivateCustomerForm v-model="customer" 
        @privateCustomerSaved="privateCustomerSaved" 
        @cancelPrivateCustomer="cancelPrivateCustomer" 
        :editingCustomer="editingCustomer"/>
    </Modal>
  </div>
</template>
<script>
import BasicDataGrid        from '../../../components/BasicDataGrid.vue';
import PrivateCustomerForm  from '../../../components/PrivateCustomerForm.vue';
import { mapState }                     from 'vuex';

import { CustomerService, DealerService }      from '@/services';

import { deepCopyObject, dealerEnum, getKeyByValue }    from "../../../modules/helpers.js";
// let customers = getDataSource('CurrentUser/Customers')
export default {
  name: 'CustomerSearch',
  components: {
    BasicDataGrid,
    PrivateCustomerForm
  },
  data() {
    return {
      dataGridKey: 'Id',
      newCustomer: {
        Id: 0,
        JdeNum: '',
        Name: '',
        LicenseNumber: null,
        Specialty: null,
        PhoneNum: '',
        FaxNum: '',
        CustomerContact: {
          FirstName: '',
          LastName: '',
          PhoneNumber: '',
          Email: null,
        },
        Address: {
          AddressId: 0,
          Name: '',
          Line1: '',
          Line2: '',
          City: '',
          StateId: null,
          ZipCode: '',
          LocationCode: '',
        },
        IsPrivate: true
      },
      customer: {},
      loading: false,
      editingCustomer: true, 
      actions: [
        {
          hint: 'Edit',
          icon: 'edit',
          emit: 'editCustomer',
        },
        {
          hint: 'Checkout',
          icon: 'file',
          emit: 'checkout'
        }],
      
      customers: [],
      columns: [
        {text: 'Customer #', value:'JdeNum', dataType: "string"}, 
        {text: 'Name', value:'Name', dataType: "string"},  
        {text: 'License #', value:'LicenseNumber', dataType: "string"},  
        {text: 'Specialty', value:'Specialty', dataType: "string"},  
        {text: 'Address', value:'Address.Line1', dataType: "string"},
        {text: 'City', value:'Address.City', dataType: "string"}, 
        {text: 'State', value:'Address.StateProvince', dataType: "string"}, 
        {text: 'Zip', value:'Address.ZipCode', dataType: "string"},
        {text: 'Phone', value:'CustomerContact.PhoneNumber', dataType: "string"},
        {text: 'Contact', value:'CustomerContactName', dataType: "string"},
        {text: 'Groups', value: 'GroupNames', dataType: 'string'},
        {text: 'Status', value:'Status', dataType: "string"},
      ],
    };
  },
  methods: {
    addNewPrivateCustomer(){
      this.editingCustomer = false;
      this.customer = deepCopyObject(this.newCustomer);
      this.toggleEditPrivateCustomerModal()
    },
    toggleEditPrivateCustomerModal(){
      this.$refs.editPrivateCustomerModal.toggle()
    },
    checkout(event){
      this.$router.push({ name: "CustomerOrder", params:{'cid' : event.row.data.Id}})
    },
    privateCustomerSaved(){
      this.customers = CustomerService.getDataSource(this.dataGridKey);
      this.toggleEditPrivateCustomerModal()
    },
    cancelPrivateCustomer(){
      
      this.toggleEditPrivateCustomerModal()
    },
    async editCustomer(event) {
      this.editingCustomer = true;
      this.customer = event.row.data

      await CustomerService.get({id: this.customer.Id})
        .then((res) => {
          this.customer = res
          this.toggleEditPrivateCustomerModal()
        })
    },
    getCustomers(){
      this.customers = CustomerService.getDataSource(this.dataGridKey)
    },
    addCustomColumnHeaders(){ 
      let dealer = getKeyByValue(dealerEnum, this.currentUser.DealerId)

      DealerService.get(this.currentUser.DealerId)
          .then(res => {

              const referenceColumnIndex = this.columns.findIndex(x => x.text === 'Groups') ?? 0

              if (res.EnableCustomerType3) {
                this.columns.splice(referenceColumnIndex, 0, {text: 'Customer Type 3', value:'CustomerType3', dataType: 'string'})
              }

              if (res.EnableCustomerType2) {
                this.columns.splice(referenceColumnIndex, 0, {text: 'Customer Type 2', value:'CustomerType2', dataType: 'string'})
              }

              if (res.EnableCustomerType1) {
                this.columns.splice(referenceColumnIndex, 0, {text: 'Customer Type 1', value:'CustomerType', dataType: 'string'})
              }
          })
          .catch(err => {
              console.log('err', err)
          })
    }
  },
  computed: {
    ...mapState(['currentUser'])
  },
  created(){
    this.getCustomers();
    this.addCustomColumnHeaders()
  }
};
</script>
<style lang="scss" scoped>
  .customer-search-page {
    // max-width: 1800px;
  }
  .btn-wrapper{
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    .btn {
      margin: 5px;
    }
  }
  .subheader-wrapper{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: -8px;
    .icon-group{
      color: $primary;
      i{
        margin: 5px;
        cursor: pointer;
      }
    }
  }
</style>
